export default function partial<FirstArg, SecondArg, ReturnType>(
  fn: (x0: FirstArg, x1: SecondArg) => ReturnType,
  arg: FirstArg
): (x1: SecondArg) => ReturnType {
  return (param: SecondArg) => fn(arg, param);
}
